import { Typography } from '@mui/material';

import { InfoCellTextWrapper } from './styledComponents';

type Props = { title: string; value: string; noWrap?: boolean };
export const InfoCell = (props: Props) => {
  const { title, value, noWrap = true } = props;
  return (
    <InfoCellTextWrapper>
      <Typography variant='overline'>
        <b>{title}</b>
      </Typography>
      <br />
      <Typography noWrap={noWrap}>{value}</Typography>
    </InfoCellTextWrapper>
  );
};
